export default __webpack_public_path__ + "static/media/sofa-1-seat-1-back.99e73c47.png";